import { render } from "./dash-header.vue?vue&type=template&id=b0d76d0c&scoped=true"
import script from "./dash-header.vue?vue&type=script&lang=js"
export * from "./dash-header.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=b0d76d0c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d76d0c"]])

export default __exports__